import { render, staticRenderFns } from "./StudentBinding.vue?vue&type=template&id=33dfd64b&scoped=true"
import script from "./StudentBinding.vue?vue&type=script&lang=js"
export * from "./StudentBinding.vue?vue&type=script&lang=js"
import style0 from "./StudentBinding.vue?vue&type=style&index=0&id=33dfd64b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dfd64b",
  null
  
)

export default component.exports